import { IApplicationState } from '../../types/redux';
import { getQuestionById } from './getQuestionById';

export const getQuestionAuthorNameById = (id: string) => (state: IApplicationState) => {
  const question = getQuestionById(id)(state);

  return question?.user?.name || '';
};
